<div
    [class]="miniState ? 'padding-2' : 'padding-3'"
    class="wrapper margin-bottom-2 flex align-items-start"
    data-cy="discussion-comment"
    [class.selected-comment]="comment.selected"
    *ngIf="!new"
>
    <app-avatar [employee]="comment.author" [size]="miniState ? 'icon' : 'inline'"></app-avatar>
    <div
        [class.margin-left-3]="!miniState"
        class="flex col justify-space-between width-full prevent-flex-item-text-overflow"
    >
        <div class="flex justify-space-between">
            <div class="flex">
                <div class="margin-right-2 name">{{ comment.author.fullName }}</div>
                <div class="margin-right-2">
                    {{ comment.createdAt | appDate: 'mediumDate' }} {{ comment.createdAt | date: 'shortTime' }}
                    <span *ngIf="isUpdated">{{ 'applicant-tracker.components.comment.edited' | appTranslate }}</span>
                </div>
                <ui-badge *ngIf="!miniState">{{ tags | appTranslate }}</ui-badge>
            </div>
            <button [matMenuTriggerFor]="meatball" class="meatballs align-right" *ngIf="canUpdate && canDelete">
                <mat-icon svgIcon="meatballHorizontal"></mat-icon>
            </button>
            <mat-menu #meatball xPosition="before">
                <button mat-menu-item (click)="editable = true">
                    {{ 'applicant-tracker.components.comment.edit' | appTranslate }}
                </button>
                <button mat-menu-item (click)="onDelete()">
                    {{ 'applicant-tracker.components.comment.delete' | appTranslate }}
                </button>
            </mat-menu>
            <ui-button type="link" (click)="onDelete()" *ngIf="!canUpdate && canDelete">{{
                'applicant-tracker.components.comment.delete' | appTranslate
            }}</ui-button>
        </div>
        <ui-badge *ngIf="miniState" class="margin-top-1 margin-bottom-1">{{ tags | appTranslate }}</ui-badge>
        <div
            id="comment-message"
            *ngIf="!editable"
            [innerHTML]="comment.message | stripTags | nl2br | sanitizeHtml"
            class="margin-top-1"
        ></div>
        <div *ngIf="editable" [class]="miniState ? 'mini-state-edit-comment' : 'flex'" class="width-full margin-top-1">
            <mat-form-field
                [class]="miniState ? 'width-full margin-bottom-2' : ''"
                class="columns-8 no-helpers no-labels no-top-padding flex-1"
            >
                <textarea
                    matInput
                    placeholder="{{
                        'applicant-tracker.components.comment.useAtToMentionAHiringManager' | appTranslate
                    }}"
                    required
                    name="comment-message"
                    [(ngModel)]="comment.message"
                    [mention]="mentions"
                    [mentionListTemplate]="mentionListTemplate"
                    (itemSelected)="attachMention($event)"
                    [rows]="rowsCount"
                ></textarea>
                <ng-template let-item="item" #mentionListTemplate>
                    <div class="flex align-items-center">
                        <app-avatar [employee]="item"></app-avatar>
                        <div>{{ item.label }}</div>
                    </div>
                </ng-template>
            </mat-form-field>
            <ui-button type="ghost" (click)="cancelUpdate()">{{
                'applicant-tracker.components.comment.cancel' | appTranslate
            }}</ui-button>
            <ui-button type="outline" (click)="onSave()" [disabled]="!isSavable" data-cy="save-comment">{{
                'applicant-tracker.components.comment.save' | appTranslate
            }}</ui-button>
        </div>
    </div>
</div>

<!-- Adding new comments outside of mini state-->
<div class="app-grid padding-top-3 padding-bottom-3" *ngIf="new && !miniState">
    <mat-form-field class="columns-4">
        <mat-label appRemoveAriaOwns>{{ 'applicant-tracker.components.comment.visibility' | appTranslate }}</mat-label>
        <mat-select
            required
            [(ngModel)]="comment.accessLevelId"
            placeholder="{{ 'applicant-tracker.components.comment.selectOption' | appTranslate }}"
            name="visibility"
            [disabled]="isUpdatable"
        >
            <mat-option [value]="0">{{
                'applicant-tracker.components.comment.onlyRecruiters' | appTranslate
            }}</mat-option>
            <mat-option [value]="hiringAccessLevelIdsEnum.hiringManager">{{
                'applicant-tracker.components.comment.onlyRecruitersHiringManagers' | appTranslate
            }}</mat-option>
            <mat-option [value]="hiringAccessLevelIdsEnum.basic">{{
                'applicant-tracker.components.comment.everyoneOnTheHiringTeam' | appTranslate
            }}</mat-option>
            <mat-option [value]="hiringAccessLevelIdsEnum.private">{{
                'applicant-tracker.components.comment.privateOnlyMe' | appTranslate
            }}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field class="columns-8">
        <mat-label>{{ 'applicant-tracker.components.comment.leaveAComment' | appTranslate }}</mat-label>
        <textarea
            matInput
            placeholder="{{
                'applicant-tracker.components.comment.useAtToMentionPeopleFromTheHiringTeam' | appTranslate
            }}"
            required
            name="message"
            [(ngModel)]="comment.message"
            [mention]="mentions"
            [mentionListTemplate]="mentionListTemplate"
            (itemSelected)="attachMention($event)"
            [rows]="rowsCount"
        ></textarea>
        <ng-template let-item="item" #mentionListTemplate>
            <div class="flex align-items-center">
                <app-avatar [employee]="item"></app-avatar>
                <div>{{ item.label }}</div>
            </div>
        </ng-template>
    </mat-form-field>
    <div class="footer width-full">
        <ui-button type="primary" [disabled]="!isSavable" (click)="onSave()"
            >{{ 'applicant-tracker.components.comment.postComment' | appTranslate }}
        </ui-button>
    </div>
</div>

<!-- Adding new comments view in mini state-->
<div class="app-grid padding-top-2" *ngIf="new && miniState">
    <mat-form-field class="columns-12">
        <mat-label>{{ 'applicant-tracker.components.comment.leaveAComment' | appTranslate }}</mat-label>
        <textarea
            matInput
            placeholder="{{
                'applicant-tracker.components.comment.useAtToMentionPeopleFromTheHiringTeam' | appTranslate
            }}"
            required
            name="message"
            [(ngModel)]="comment.message"
            [mention]="mentions"
            [mentionListTemplate]="mentionListTemplate"
            (itemSelected)="attachMention($event)"
            [rows]="rowsCount"
        ></textarea>
        <ng-template let-item="item" #mentionListTemplate>
            <div class="flex align-items-center">
                <app-avatar [employee]="item"></app-avatar>
                <div>{{ item.label }}</div>
            </div>
        </ng-template>
    </mat-form-field>
    <mat-form-field class="columns-8">
        <mat-label appRemoveAriaOwns>{{ 'applicant-tracker.components.comment.visibility' | appTranslate }}</mat-label>
        <mat-select
            required
            [(ngModel)]="comment.accessLevelId"
            placeholder="{{ 'applicant-tracker.components.comment.selectOption' | appTranslate }}"
            name="visibility"
            [disabled]="isUpdatable"
        >
            <mat-option [value]="0">{{
                'applicant-tracker.components.comment.onlyRecruiters' | appTranslate
            }}</mat-option>
            <mat-option [value]="hiringAccessLevelIdsEnum.hiringManager">{{
                'applicant-tracker.components.comment.onlyRecruitersHiringManagers' | appTranslate
            }}</mat-option>
            <mat-option [value]="hiringAccessLevelIdsEnum.basic">{{
                'applicant-tracker.components.comment.everyoneOnTheHiringTeam' | appTranslate
            }}</mat-option>
            <mat-option [value]="hiringAccessLevelIdsEnum.private">{{
                'applicant-tracker.components.comment.privateOnlyMe' | appTranslate
            }}</mat-option>
        </mat-select>
    </mat-form-field>
    <div class="footer margin-top-3 columns-4">
        <ui-button type="primary" [disabled]="!isSavable" (click)="onSave()"
            >{{ 'applicant-tracker.components.comment.post' | appTranslate }}
        </ui-button>
    </div>
</div>
